







































// @ts-ignore
import { useRouter } from "@/@core/utils/utils";
// @ts-ignore
import router from "@/router";
import useAppData from "@/views/components/inbox/active-chat-sidebars/useAppData";
import { ref, watch } from "@vue/composition-api";

export default {
    setup() {
        const { route } = useRouter();
        const { appModalContent, appModalIsActive, activeApp, appData } = useAppData();
        watch(
            () => route.value.fullPath,
            () => {
                appModalIsActive.value = false;
            }
        );

        const modalContent = ref();

        return { appModalContent, appModalIsActive, activeApp, appData, modalContent };
    },
};
